import findAncestor from "./findAncestor";

export default () => {

    const hamburger = document.querySelector('[data-hamburger]');
    const navigation = document.querySelector('.navigation');
    const firstList = document.querySelector('.navigation__list');
    const closeButtons = document.querySelectorAll('[data-close]');

    hamburger.addEventListener('click', (e) => {
        e.preventDefault();
        if (hamburger.classList.contains('active')) {
            hamburger.classList.remove('active');
            navigation.classList.remove('active');
            const lists = document.querySelectorAll('.navigation__list');
            for (const list of lists) {
                list.classList.remove('active');
            }
            navigation.setAttribute('data-active', 0);
        } else {
            hamburger.classList.add('active');
            navigation.classList.add('active');
            firstList.classList.add('active');
        }
        return false;
    });

    for (const btn of closeButtons) {
        btn.addEventListener('click', () => {
            hamburger.classList.remove('active');
            navigation.classList.remove('active');
            // const lists = document.querySelectorAll('.navigation__list');
            // for (const list of lists) {
            //     list.classList.remove('active');
            // }
            // navigation.setAttribute('data-active', 0);
        });
    }

    const moreButtons = document.querySelectorAll('[data-more]');
    for (const btn of moreButtons) {

        btn.addEventListener('click', () => {

            const parent = findAncestor(btn, '[data-nav-list]');

            const child = parent.querySelector('.navigation__list');
            child.classList.add('active');

            const level = child.getAttribute('data-level');
            navigation.setAttribute('data-active', level);

        });

    }


    const backButtons = document.querySelectorAll('[data-back]');
    for (const btn of backButtons) {
        btn.addEventListener('click', () => {
            const parent = findAncestor(btn, '[data-nav-list]');
            const child = parent.querySelector('.navigation__list');
            child.classList.remove('active');
            const level = child.getAttribute('data-level');
            navigation.setAttribute('data-active', level - 1);
        });
    }

    const closeDivs = document.querySelectorAll('.navigation__close');
    for (const div of closeDivs) {
        div.addEventListener('click', () => {

            const list = findAncestor(div, '.navigation__list');
            const level = list.getAttribute('data-level');

            const subs = list.querySelectorAll('.navigation__list.active');
            for (const sub of subs) {
                sub.classList.remove('active');
            }

            navigation.setAttribute('data-active', level);
        });
    }
}
